import React, { useContext, useState } from "react";
import { useCookies } from "react-cookie";
import styled, { ThemeContext } from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { Modal } from "notes";
import { RegistrationForm, Countdown, PoweredBy } from "./Components";
import { Layout } from "../Layout";
import analytics from "services/analytics";
import { fonts } from "theme/fonts";
import { Duration } from "luxon";
import { TimeContext } from "Components";

import playIcon from "Images/play-button.png";
import headerBgImage from "Images/header-img.jpg";

export const Register = React.memo(({ event, onSuccess, ...props }) => {
  const themeContext = useContext(ThemeContext);
  const { time } = useContext(TimeContext);
  const [open, setOpen] = useState(false);
  const [cookies, setCookie] = useCookies([process.env.REACT_APP_EVENT_ID]);

  const [regPartOne, setRegPartOne] = useState(false);
  const [regPartTwo, setRegPartTwo] = useState(false);
  const [formData, setFormData] = useState({});

  let RegFormContent;

  let api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  let desktopImage = `${api}/o/${event?.register?.artistImageDesktop?.path}?alt=media`;
  let mobileImage = `${api}/o/${event?.register?.artistImageMobile?.path}?alt=media`;
  let headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  let footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;

  // const startDate = event.start.toFormat("LLLL d");
  // const startTime = event.start.toFormat("h:mm a");

  const handleSuccess = (admin, token, formPart, email, zip) => {
    onSuccess(admin, token, formPart);

    if (formPart === 1) {
      setRegPartOne(true);
      setCookie("email", email, { maxAge: 31622400 });
      setCookie("zip", zip, { maxAge: 31622400 });
      setFormData({ zip });
    } else if (formPart === 2) {
      setRegPartTwo(true);
      setRegPartOne(false);
    }
  };

  const setModalVisible = (bool) => {
    setOpen(bool);
    if (bool) {
      analytics.fireEvent({
        category: "Video",
        action: "Hero Video",
        label: window.location.host,
      });
    } else {
      analytics.fireEvent({
        category: "Video",
        action: "Close Button",
        label: window.location.host,
      });
    }
  };

  if (event.campaignEnd < time) {
    RegFormContent = (
      <>
        <h3>{event.postShow.closedHeader}</h3>
        <p>{ReactHtmlParser(event.postShow.pastBody)}</p>
      </>
    );
  } else {
    if (cookies?.registration === "complete" || regPartTwo) {
      const timeToStart =
        time < event.start &&
        Duration.fromMillis(event.start - time).shiftTo(
          "days",
          "hours",
          "minutes",
          "seconds",
          "milliseconds"
        );

      const timer = {
        label: "Tu Show Iniciará en Esta Página En",
        days: timeToStart.days,
        hours: timeToStart.hours,
        minutes: timeToStart.minutes,
        seconds: timeToStart.seconds,
      };

      RegFormContent = (
        <>
          <Countdown {...timer} />
          <PoweredBy zipCode={cookies?.zip ?? formData?.zip} />
        </>
      );
    } else if (cookies?.registration === "incomplete" || regPartOne) {
      RegFormContent = (
        <>
          <RegistrationForm
            formPart={2}
            formData={event}
            email={cookies?.email}
            onSuccess={handleSuccess}
          />
          <PoweredBy zipCode={cookies?.zip ?? formData?.zip} />
        </>
      );
    } else {
      RegFormContent = (
        <RegistrationForm
          formPart={1}
          formData={event}
          onSuccess={handleSuccess}
        />
      );
    }
  }

  return (
    <Layout
      // header
      headerTitles={event.register.header}
      headerShowLogo={false}
      headerLogo={headerLogo}
      headerBgImage={headerBgImage}
      headerRegistration={true}
      headerCTA={event.register.headerCTA}
      setModalVisible={setModalVisible}
      // hero
      heroContent={false}
      // heading
      // main
      // add-ons
      noAddons
      // footer
      footerRegistration={true}
      footerShowText={true}
      footerShowLogo={true}
      footerLogo={footerLogo}
      footerText={event?.register?.footer}
      footerPrivacyPolicy={event?.footer}
    >
      <Registration>
        <Content as="section" id="registration-content">
          <ContentHeader>
            <ContentHeaderContainer>
              {themeContext.register.altLogo?.active && (
                <AltLogoLink
                  href="https://es.buyfordnow.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    analytics.fireEvent({
                      category: "External Link",
                      action: "Truck Month Logo",
                      label: window.location.href,
                    });
                  }}
                >
                  <AltLogo src={headerLogo} />
                </AltLogoLink>
              )}
              {/* <HeaderContent>
                <h1>RaeLynn</h1>
                <h2>and the 2021 Ford-F150</h2>
              </HeaderContent> */}
            </ContentHeaderContainer>
          </ContentHeader>

          <ContentContainer>{RegFormContent}</ContentContainer>
        </Content>

        <ArtistImage
          as="section"
          id="artist-image"
          desktopImage={desktopImage}
          mobileImage={mobileImage}
        >
          {themeContext.register.overlayImage.active && (
            <OverlayContainer>
              <ModalLink onClick={setModalVisible}>
                <OverlayImage src={playIcon} />
                <OverlayTitle>Ford F-150 2021</OverlayTitle>
              </ModalLink>
              <OverlayButtonContainer>
                <OverlayButton
                  href="https://es.buyfordnow.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    analytics.fireEvent({
                      category: "External Link",
                      action: "Build and Price",
                      label: window.location.href,
                    });
                  }}
                >
                  Diseña y Cotiza
                </OverlayButton>
              </OverlayButtonContainer>
            </OverlayContainer>
          )}
        </ArtistImage>
      </Registration>

      <VideoModal size="large" open={open} setOpen={setModalVisible}>
        <VideoModalContainer>
          <Video
            src="https://www.youtube.com/embed/7MRoA17QrI4"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </VideoModalContainer>
      </VideoModal>
    </Layout>
  );
});

// ======== REGISTRATION CONTAINER ======== //

const Registration = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
  }
`;

// ======== CONTENT / LEFT SIDE ======== //

const Content = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  color: #102b4e;
  margin-bottom: 15px;
  box-shadow: 0 3px 6px 0px rgb(0 0 0 / 20%);

  ::before,
  ::after {
    content: "";
    height: 40px;
    width: 40px;
    background: #102b4e;
    margin: 0 auto;
    display: flex;
  }

  ::before {
    margin-top: -20px;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  ::after {
    margin-bottom: -20px;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    width: 450px;
    margin-bottom: 0;
    margin-top: -138px;
  }
`;

const ContentHeader = styled.div`
  border-bottom: 1px solid rgba(16, 43, 78, 0.5);
`;

const ContentHeaderContainer = styled.div`
  display: flex;
  padding: 25px 15px;
  max-width: 650px;
  margin: 0 auto;
  align-items: end;
  justify-content: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 8px 35px;
    max-width: 450px;
  }
`;

const ContentContainer = styled.div`
  margin: 0 auto;
  padding: 25px 15px 50px;
  width: 100%;
  height: 100%;
  max-width: 650px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    max-width: unset;
    padding: 24px;
    max-width: 450px;
    min-height: 650px;
  }
`;

const AltLogoLink = styled.a`
  width: 100%;
  max-width: 94px;
`;

const AltLogo = styled.img`
  width: 100%;
`;

// const HeaderContent = styled.div`
//   color: black;
//   font-family: ${fonts.brand.bold};
//   line-height: 1;

//   h1 {
//     margin: 0;
//     text-transform: uppercase;
//     font-size: 11.25vw;
//   }

//   h2 {
//     margin: 0;
//     text-transform: uppercase;
//     font-size: 4.18vw;
//   }

//   @media only screen and (min-width: 550px) {
//     h1 {
//       font-size: 12vw;
//     }

//     h2 {
//       font-size: 4.5vw;
//     }
//   }

//   @media only screen and (min-width: 680px) {
//     h1 {
//       font-size: 85px;
//     }

//     h2 {
//       font-size: 31.75px;
//     }
//   }

//   @media only screen and ${(props) => props.theme.maxMedia.medium} {
//     h1 {
//       font-size: 51px;
//     }

//     h2 {
//       font-size: 19px;
//     }
//   }
// `;

// ======== ARTIST IMAGE / RIGHT SIDE ======== //

const ArtistImage = styled.div`
  align-items: flex-start;
  background-color: #000000;
  background-image: url(${(props) => props.mobileImage});
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: ${(9 / 16) * 100}%;
  position: relative;
  background-position: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    background-image: url(${(props) => props.desktopImage});
    flex-grow: 1;
    padding-top: 0;
  }
`;

const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 0 7vw 7vw 0;
    align-items: unset;
    top: unset;
    left: unset;
    width: unset;
    height: unset;
  }
`;

const OverlayImage = styled.img`
  width: 22vw;
  max-width: 100px;
  margin-bottom: 10px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    max-width: 125px;
  }
`;

const OverlayTitle = styled.h3`
  color: #ffffff;
  text-transform: uppercase;
  font-family: ${fonts.header};
  font-size: 9vw;
  margin-bottom: 10px;
  font-family: ${fonts.brandCondensedBold};

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 5vw;
  }
`;

const OverlayButtonContainer = styled.div`
  width: 100%;
  padding: 0 15px;
  position: absolute;
  bottom: -35px;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    position: relative;
    bottom: unset;
    padding: 0;
    width: unset;
  }
`;

const OverlayButton = styled.a`
  font-family: ${fonts.brandLight};
  color: #ffffff;
  background: #4580dd;
  padding: 25px;
  display: flex;
  justify-content: center;
  text-decoration: none;
  line-height: 1.15;
  @media only screen and ${(props) => props.theme.maxMedia.small} {
    font-size: 24px;
  }
`;

// ======== MODAL ======== //

const ModalLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }
`;

const VideoModal = styled(Modal)`
  justify-content: center;
  min-height: unset;
  position: relative;

  svg {
    top: 10px;
    right: 10px;
  }
`;

const VideoModalContainer = styled.div`
  padding-top: 56.25%;
  position: relative;
`;

const Video = styled.iframe`
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  border: 0;
`;
